/**
 * Auth guard hook — checks if the user has a connected wallet.
 *
 * Returns `isAuthenticated` and `promptConnect` to trigger the login modal
 * when the user attempts an authenticated action while disconnected.
 *
 * Uses useWallet() abstraction — never imports Privy or wagmi directly.
 */

import { useWallet } from "./use-wallet";

type RequireAuthResult = {
	isAuthenticated: boolean;
	promptConnect: () => void;
};

export function useRequireAuth(): RequireAuthResult {
	const { isConnected, login } = useWallet();

	function promptConnect() {
		if (!isConnected) {
			login();
		}
	}

	return { isAuthenticated: isConnected, promptConnect };
}
